import Vue from "vue/dist/vue.esm";
import VueI18n from "vue-i18n";
import getLocale from "/utils/locale";
import CategoryExplorer from "/features/category-explorer/components/category-explorer.vue";

const init = (container) => {
  const {
    categories: categoriesJson,
    defaultCategorySlug,
    chipModifiers: chipModifiersJson
  } = container.dataset;

  const categories = JSON.parse(categoriesJson);

  const chipModifiers = JSON.parse(chipModifiersJson || "[]");

  Vue.use(VueI18n);

  new Vue({
    el: container,
    i18n: new VueI18n({ locale: getLocale() }),
    render: h => h(CategoryExplorer, {
      props: {
        categories,
        defaultCategorySlug,
        chipModifiers
      }
    })
  });
};

export const eventHandlers = {
  "abtest:toggled": () => {
    document.querySelectorAll(".js-category-explorer").forEach(el => {
      init(el);
    });
  }
};
